import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import CategoryPage from "../pages/category/page";
import VideoPage from "../pages/video/page";
import AboutPage from "../pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/category/:categorySlug",
    element: <CategoryPage />,
  },
  {
    path: "/video/:videoId",
    element: <VideoPage />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
